import React, {Fragment} from 'react';
import Page from "../../BaseComponents/Page/Page";
import PropTypes from 'prop-types'
import {FaRegularIcon, FaSolidIcon} from "../../FontAwesomeIcons";
import './SessionChooserPage.css';
import moment from "moment";
import GruppiAPI from "../../../api/GruppiAPI";
import {PageFooter} from "../../BaseComponents/Page/PageFooter";
import {swalConfirm, swalError, swalInfo, swalLoading, swalSuccess} from "../../../helpers/SweetAlertWrapper";
import {WAITING_LIST_SHOPS} from "../Constants";
import {NegozioOpenStore} from "../../../stores/NegozioOpenStore";
import {SessionCardView} from "./SessionCardView";
import {ModuloGruppiAPI} from "../../../api/ModuloGruppi/ModuloGruppiAPI";
import {addCssToHead} from "../../../helpers/CssHelpers";
import {AvailabilityDatePicker} from "../../BaseComponents/AvailabilityDatePicker";
import {FuxPaginatorItemSkeleton} from "../../BaseComponents/FuxCursorPaginator/FuxPaginatorItemSkeleton";


addCssToHead(`


`)

export default class SessionChooserPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            onDismiss: props.onDismiss,
            onChoose: props.onChoose,
            selectedDate: null,
            selectedInterval: [],
            dateDisponibili: {},
            startDate: 'now',
            requestDirection: 'next',
            nextButtonClicks: 0,
            requestedDate: null,
            datesHistory: {},
            fetching: false,
            //waiting list
            showFullGroupSessions: false
        };

    }

    componentDidMount() {
        this.fetchNewData(this.state);
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        if (nextState.startDate !== this.state.startDate || nextState.requestDirection !== this.state.requestDirection) {
            this.fetchNewData(nextState);
        }
        return true;
    }

    fetchNewData = state => {
        var newState = {};
        this.setState({fetching: true});

        //Per evitare che le date visualizzate siano maggiori di quelle richieste dall'utente
        var maxDates = 6
        if (state.requestDirection === "next" && this.props.maxVisibleDays) {
            maxDates = (this.props.maxVisibleDays - Object.keys(this.state.datesHistory).length > 5) ? 6 : this.props.maxVisibleDays - Object.keys(this.state.datesHistory).length
        }

        //Questo calcolo di startDate permette di non includere la startDate tra le date prossime date richieste
        const startDate = state.startDate === 'now' ?
            //Se non ho una data di partenza uso quella attuale
            moment().format('DD-MM-YYYY') :
            state.requestDirection === 'next' ?
                //Se sto andando avanti allora devo partire dal giorno successivo all'ultima data disponibile (this.state.startDate)
                moment(state.startDate, 'DD-MM-YYYY').add(1, 'day').format('DD-MM-YYYY')
                :
                //Se sto andando indietro allora devo partire dal giorno precedente alla prima data disponibile (this.state.startDate)
                moment(state.startDate, 'DD-MM-YYYY').subtract(1, 'day').format('DD-MM-YYYY');

        GruppiAPI.getAvailableDates(this.props.id_gruppo, startDate, state.requestDirection, this.props.partecipanti, maxDates, state.showFullGroupSessions ? 1 : 0)
            .then((dateDisponibili) => {
                newState.dateDisponibili = dateDisponibili;
                newState.selectedDate = Object.keys(dateDisponibili)[0];
                newState.fetching = false;

                //Se ha selezionato una data diretto lo avviso che non è disponibile
                const fetchedDates = Object.keys(dateDisponibili);
                if (this.state.requestedDate && !fetchedDates.includes(this.state.requestedDate)) {
                    swalInfo(`La data ${moment(this.state.requestedDate, "DD-MM-YYYY").format("DD/MM/YYYY")} non è disponibile. Ti mostriamo le prime date successive disponibili.`)
                }
                newState.requestedDate = null

                /**
                 * In caso di direction "prev" allora rimuovo le date attualmente visualizzate dalla history,
                 * prima di sostituirle con quelle appena fetchate
                 */
                newState.datesHistory = {...this.state.datesHistory};
                console.log(state.requestDirection)
                if (state.requestDirection === "back") {
                    Object.keys(this.state.dateDisponibili).map(d => delete newState.datesHistory[d]);
                }
                Object.keys(dateDisponibili).map(d => newState.datesHistory[d] = true);

                console.log(dateDisponibili);
                this.setState(newState);
            });
    }

    handleConfirm = _ => {
        const constraints = this.getBlockingCustomFieldConstraints();
        if (constraints.length) {
            swalError(<span>Non puoi prenotare per questa giornata: {constraints.map(constraint => constraint.name).join(', ')}</span>);
            return;
        }

        if (this.checkAdvancedDaysPassed()) {
            swalError(`Attenzione! In questa attività puoi prenotare con un massimo di ` + this.props.advanceDays + ` giorni di anticipo`)
            return;
        }

        if (!this.state.selectedInterval.length) {
            swalError(`Scegli un opzione prima di proseguire`)
            return;
        }

        for (let i in this.state.selectedInterval) {
            const session = this.state.selectedInterval[i];
            if (session.posti_disponibili < this.props.partecipanti) {
                swalError(`I posti disponibili dalle ${session.orario_inizio} alle ${session.orario_fine} sono solo ${session.posti_disponibili}`);
                return;
            }
        }

        this.state.onChoose({
            data: this.state.selectedDate,
            sessioni: this.state.selectedInterval,
        });
    }

    handleNextDays = _ => {
        var dateList = Object.keys(this.state.dateDisponibili);
        this.setState({
            startDate: dateList[dateList.length - 1],
            requestDirection: 'next',
            nextButtonClicks: this.state.nextButtonClicks + 1
        });
    }

    handleBackDays = _ => {
        var dateList = Object.keys(this.state.dateDisponibili);
        this.setState({
            startDate: dateList[0],
            requestDirection: 'back',
            nextButtonClicks: this.state.nextButtonClicks - 1
        });
    }

    handleDirectDateChoose = date => {
        const selectedDate = moment(date, "DD-MM-YYYY");
        const today = moment().startOf("day");

        const diffInDays = selectedDate.diff(today, "days");

        if (this.props.advanceDays > 0 && diffInDays > this.props.advanceDays) {
            return swalError(
                "Attenzione, puoi prenotare con un massimo di " +
                this.props.advanceDays +
                " giorni di anticipo"
            );
        }

        this.setState({
            startDate: selectedDate.clone().subtract(1, "day").format("DD-MM-YYYY"),
            requestDirection: "next",
            requestedDate: selectedDate.format("DD-MM-YYYY"),
            datesHistory: {},
            nextButtonClicks: 0,
            selectedDate: null,
            selectedInterval: [],
            fetching: true
        });
    };

    handleDayClick = dateString => {
        console.log(dateString);
        console.log(this.state.dateDisponibili[dateString].time);
        this.setState({
            selectedDate: dateString,
            selectedInterval: []
        });
    }

    handleTimeChange(session) {
        var selected = this.state.selectedInterval.slice();
        var index = this.isSessionSelected(session)
        if (index !== false) { //Deseleziono
            selected.splice(index, 1);
            this.setState({selectedInterval: selected});
            return;
        }

        if (selected.length + 1 > this.props.maxSessions) {
            //Elimino l'elemento più remoto e poi aggiungo quello appena selezionato
            selected.splice(0, 1);
        }

        selected.push(session);
        this.setState({
            selectedInterval: selected
        })
    }

    handleSessionChoose = (session, full = 0) => {
        if (!full) {
            return this.handleTimeChange(session)
        }
        return this.props.onJoinToWaitingList(session, this.state.selectedDate);
    }


    isSessionSelected(session) {
        var str = JSON.stringify(session);
        for (var i in this.state.selectedInterval) {
            if (str === JSON.stringify(this.state.selectedInterval[i])) {
                return i;
            }
        }
        return false;
    }

    toggleShowFullGroupSessions = _ => {
        this.setState({showFullGroupSessions: !this.state.showFullGroupSessions}, _ => {
            this.fetchNewData(this.state)
        });
    }

    getBlockingCustomFieldConstraints = () => {
        const selectedDate = moment(this.state.selectedDate, "DD-MM-YYYY", true);
        if (!selectedDate.isValid()) return [];

        return (this.props.customFieldBookConstraints || []).filter(constraint => {
            const expiresOn = moment(constraint.expires_on, "YYYY-MM-DD", true);
            return expiresOn.isValid() && selectedDate.isSameOrAfter(expiresOn, "day");
        });
    }

    //Se true vuol dire che i giorni di anticipo sono stati superati e quindi l'utente non potrà prenotare
    checkAdvancedDaysPassed = () => {
        if (!this.props.advanceDays) return false;

        const selectedDate = moment(this.state.selectedDate, "DD-MM-YYYY").startOf("day");
        const today = moment().startOf("day");

        //La differenza viene calcolata tra la mezzanotte e la mezzanotte
        const diffInDays = selectedDate.diff(today, "days");

        //Se la differenza è maggiore sono in anticipo quindi non potrà prenotare
        if (diffInDays > this.props.advanceDays) return true;

        //Se la differenza è minore potrà prenotare
        if (diffInDays < this.props.advanceDays) return false;

        /**
         * Se si tratta della giornata in cui vengono aperte le prenotazioni
         * controllo l'orario di apertura
         */
        const [openingHour, openingMinute] = this.props.advanceOpeningHours.split(":").map(Number);
        const openingTimeToday = moment()
            .startOf("day")
            .hour(openingHour)
            .minute(openingMinute);

        return !moment().isSameOrAfter(openingTimeToday);
    };

    render() {
        const canGoPrev = true;
        const canGoNext = !this.props.maxVisibleDays || this.props.maxVisibleDays > Object.keys(this.state.datesHistory).length;
        const blockingConstraints = this.getBlockingCustomFieldConstraints();
        const bookingDisabled = this.checkAdvancedDaysPassed();

        return (
            <Page
                title={"Data e ora"}
                leftIcon={<FaSolidIcon name={"chevron-left"}/>}

                onLeftIconClick={this.props.onDismiss}
                active={true}
                content={
                    <div className={"container pt-3"}>

                        {/* Mostro le attuali date disponibili */}
                        <div className={"my-3"}>
                            <AvailabilityDatePicker
                                fetching={this.state.fetching}
                                availableDates={this.state.dateDisponibili}
                                selectedDate={this.state.selectedDate}
                                upperLimitReached={!canGoNext}
                                lowerLimitReached={!canGoPrev}
                                onNextDaysRequest={this.handleNextDays}
                                onBackDaysRequest={this.handleBackDays}
                                onDirectDateChose={this.handleDirectDateChoose}
                                onDayClick={this.handleDayClick}
                            />

                            {
                                !canGoNext &&
                                <div className={"my-2 text-muted text-center small"}>
                                    <FaSolidIcon name={"exclamation-triangle"} className={"text-warning"}/> &nbsp;
                                    Non puoi visualizzare altre date future a causa dei limiti impostati dall'attività
                                </div>
                            }

                        </div>

                        <div className={"row my-2"}>
                            {
                                blockingConstraints.length > 0 &&
                                <div className={"col-12"}>
                                    <div className={"px-2 my-2 alert alert-warning text-center small"} role={"alert"}>
                                        Non puoi prenotare per questa giornata:
                                        {blockingConstraints.map(constraint => (
                                            <div key={constraint.field_id}>
                                                <strong>{constraint.name}</strong>
                                                {` (scadenza: ${moment(constraint.expires_on, "YYYY-MM-DD", true).format("DD/MM/YYYY")})`}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            }

                            {
                                this.checkAdvancedDaysPassed() ?
                                    <div className={"px-2 m-2 alert alert-primary text-center small"}>
                                        In questa attività le prenotazioni vengono aperte
                                        con {this.props.advanceDays} giorni di anticipo
                                        alle {this.props.advanceOpeningHours}
                                    </div> : ""
                            }

                            {
                                this.state.fetching ?
                                    Array.from(Array(3), (_, x) => x).map(_ =>
                                        <div className={"col-12 d-flex justify-content-center my-1"}>
                                            <FuxPaginatorItemSkeleton width={310} height={64}/>
                                        </div>
                                    )
                                    :
                                    !this.state.selectedDate ? '' : this.state.dateDisponibili[this.state.selectedDate].map((sessione, i) => {
                                        const checked = this.isSessionSelected(sessione);
                                        return (
                                            <div className={"col-12 px-2 text-center"} key={i}>
                                                <SessionCardView
                                                    session={sessione}
                                                    checked={checked}
                                                    partecipanti={this.props.partecipanti}
                                                    onSessionChoose={this.handleSessionChoose}
                                                    hideEndTime={this.props.hideEndTime}
                                                    hideAvailability={this.props.hideAvailability}
                                                />
                                            </div>
                                        );
                                    })
                            }
                        </div>

                        {
                            !(NegozioOpenStore.infoNegozio && parseInt(NegozioOpenStore.infoNegozio.impostazioni.show_full_group_sessions) || 0) && //Caso in cui l'attività del mostra di default
                            (NegozioOpenStore.infoNegozio && WAITING_LIST_SHOPS.includes(parseInt(NegozioOpenStore.infoNegozio.id_negozio))) &&
                            <div className={"w-100 text-center mt-2"}>
                                {
                                    this.state.showFullGroupSessions ?
                                        <button className={"btn btn-sm btn-link text-primary p-1"}
                                                onClick={this.toggleShowFullGroupSessions}>
                                            Nascondi orari non disponibili <FaSolidIcon name={"eye-slash"}/>
                                        </button> :
                                        <div>
                                            <small>
                                                Non trovi l'orario che desideri?
                                                Puoi <b>mostrare gli orari non disponibili</b> e ricevere una notifica
                                                se si libera
                                                un posto.
                                            </small>
                                            <button className={"btn btn-sm btn-primary text-on-bg-primary p-1 mt-2"}
                                                    onClick={this.toggleShowFullGroupSessions}>
                                                Mostra orari <FaSolidIcon name={"eye"}/>
                                            </button>
                                        </div>
                                }
                            </div>
                        }
                    </div>
                }
                footer={
                    <PageFooter className={"bg-main-z2 p-3 border-top"}>
                        <button
                            className={"btn btn-lg btn-block btn-primary text-on-bg-primary"}
                            disabled={bookingDisabled}
                            onClick={this.handleConfirm}>
                            {this.props.confirmText ? this.props.confirmText : "Prenota"} <FaSolidIcon
                            name={"chevron-right"}/>
                        </button>
                    </PageFooter>
                }
            />
        );
    }

}


SessionChooserPage.propTypes = {
    id_gruppo: PropTypes.string || PropTypes.number,
    partecipanti: PropTypes.number,
    onChoose: PropTypes.func,
    onDismiss: PropTypes.func,
    onJoinToWaitingList: PropTypes.func,
    maxSessions: PropTypes.number,
    hideAvailability: PropTypes.bool,
    maxVisibleDays: PropTypes.number,
    advanceDays: PropTypes.number,
    advanceOpeningHours: PropTypes.string,
    customFieldBookConstraints: PropTypes.arrayOf(PropTypes.shape({
        field_id: PropTypes.number,
        name: PropTypes.string,
        expires_on: PropTypes.string
    })),
    hideEndTime: PropTypes.bool
};
